import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { createModules, createRelationType, fetchModules, fetchRelationType, removeModules, removeRelationType, updateModules, updateRelationType } from "../../service/api";


export const getRelationType = createAsyncThunk(
    "relation/getAll",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchRelationType(params)
            console.log("fetch relation", response)
            return response.data.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)

        }
    }
)



export const addRelationType = createAsyncThunk(
    "relation/add",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await createRelationType(formValue)
            if (response.status === 201) {
                console.log("add relation", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)

export const editRelationType = createAsyncThunk(
    "relation/edit",
    async (newData, { rejectWithValue }) => {
        try {
            const response = await updateRelationType(newData)
            if (response.status === 201) {
                console.log("edit relation", response)
            }
        } catch (error) {
            console.log(error)
            return rejectWithValue(error.response.data || error.message)
        }
    }
)


export const deleteRelationType = createAsyncThunk(
    "relation/delete",
    async (newData, { rejectWithValue }) => {
        try {
            const response = await removeRelationType(newData)
            if (response.status === 201) {
                console.log("delte relation", response)
            }
        } catch (error) {
            console.log(error)
            return rejectWithValue(error.response.data || error.message)
        }
    }
)



const relationTypeSlice = createSlice({
    name: "relations",
    initialState: {
        relationTypeList: [],
        isLoading: false,
        actionLoader: false,
        error: null,
        totalPage: 0,
        current: 1,
        limit: 10,
        searchParams: ""
    },
    reducers: {
        setPagination: (state, action) => {
            state.current = action.payload;
        },
        setSearchParams: (state, action) => {
            state.searchParams = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getRelationType.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getRelationType.fulfilled, (state, action) => {
                state.isLoading = false;
                state.relationTypeList = action.payload.data;
                state.totalPage = action.payload.totalPages
            })
            .addCase(getRelationType.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })




            // POST

            .addCase(addRelationType.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(addRelationType.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(addRelationType.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })

            // PUT
            .addCase(editRelationType.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(editRelationType.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(editRelationType.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })

            // delete
            .addCase(deleteRelationType.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(deleteRelationType.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(deleteRelationType.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })
    }
})
export const { setSearchParams, setPagination } = relationTypeSlice.actions;

export default relationTypeSlice.reducer;